module.exports = __webpack_public_path__ + "static/media/Free-tagIcon.e4f311bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon/Free-tagIcon.png
// module id = 1827
// module chunks = 0